/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImportBusinessBodyItem
 */
export interface ImportBusinessBodyItem {
    /**
     * 
     * @type {string}
     * @memberof ImportBusinessBodyItem
     */
    devour_merchant_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBusinessBodyItem
     */
    olo_vendor_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBusinessBodyItem
     */
    chowly_api_key?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBusinessBodyItem
     */
    merchant_account_email?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBusinessBodyItem
     */
    merchant_parent_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBusinessBodyItem
     */
    merchant_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBusinessBodyItem
     */
    merchant_internal_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBusinessBodyItem
     */
    merchant_description?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBusinessBodyItem
     */
    merchant_email?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBusinessBodyItem
     */
    merchant_phone?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBusinessBodyItem
     */
    merchant_address_line1?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBusinessBodyItem
     */
    merchant_address_line2?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBusinessBodyItem
     */
    merchant_address_city?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBusinessBodyItem
     */
    merchant_address_state?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBusinessBodyItem
     */
    merchant_address_zipcode?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBusinessBodyItem
     */
    merchant_address_country?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBusinessBodyItem
     */
    merchant_address_longitude?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBusinessBodyItem
     */
    merchant_address_latitude?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBusinessBodyItem
     */
    merchant_address_place_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBusinessBodyItem
     */
    merchant_timezone?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBusinessBodyItem
     */
    merchant_brands?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBusinessBodyItem
     */
    merchant_categories?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBusinessBodyItem
     */
    merchant_prep_time?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBusinessBodyItem
     */
    merchant_handoff?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBusinessBodyItem
     */
    merchant_delivery_distance?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBusinessBodyItem
     */
    merchant_brand_size?: string;
}

/**
 * Check if a given object implements the ImportBusinessBodyItem interface.
 */
export function instanceOfImportBusinessBodyItem(value: object): value is ImportBusinessBodyItem {
    return true;
}

export function ImportBusinessBodyItemFromJSON(json: any): ImportBusinessBodyItem {
    return ImportBusinessBodyItemFromJSONTyped(json, false);
}

export function ImportBusinessBodyItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportBusinessBodyItem {
    if (json == null) {
        return json;
    }
    return {
        
        'devour_merchant_id': json['devour_merchant_id'] == null ? undefined : json['devour_merchant_id'],
        'olo_vendor_id': json['olo_vendor_id'] == null ? undefined : json['olo_vendor_id'],
        'chowly_api_key': json['chowly_api_key'] == null ? undefined : json['chowly_api_key'],
        'merchant_account_email': json['merchant_account_email'] == null ? undefined : json['merchant_account_email'],
        'merchant_parent_id': json['merchant_parent_id'] == null ? undefined : json['merchant_parent_id'],
        'merchant_name': json['merchant_name'] == null ? undefined : json['merchant_name'],
        'merchant_internal_name': json['merchant_internal_name'] == null ? undefined : json['merchant_internal_name'],
        'merchant_description': json['merchant_description'] == null ? undefined : json['merchant_description'],
        'merchant_email': json['merchant_email'] == null ? undefined : json['merchant_email'],
        'merchant_phone': json['merchant_phone'] == null ? undefined : json['merchant_phone'],
        'merchant_address_line1': json['merchant_address_line1'] == null ? undefined : json['merchant_address_line1'],
        'merchant_address_line2': json['merchant_address_line2'] == null ? undefined : json['merchant_address_line2'],
        'merchant_address_city': json['merchant_address_city'] == null ? undefined : json['merchant_address_city'],
        'merchant_address_state': json['merchant_address_state'] == null ? undefined : json['merchant_address_state'],
        'merchant_address_zipcode': json['merchant_address_zipcode'] == null ? undefined : json['merchant_address_zipcode'],
        'merchant_address_country': json['merchant_address_country'] == null ? undefined : json['merchant_address_country'],
        'merchant_address_longitude': json['merchant_address_longitude'] == null ? undefined : json['merchant_address_longitude'],
        'merchant_address_latitude': json['merchant_address_latitude'] == null ? undefined : json['merchant_address_latitude'],
        'merchant_address_place_id': json['merchant_address_place_id'] == null ? undefined : json['merchant_address_place_id'],
        'merchant_timezone': json['merchant_timezone'] == null ? undefined : json['merchant_timezone'],
        'merchant_brands': json['merchant_brands'] == null ? undefined : json['merchant_brands'],
        'merchant_categories': json['merchant_categories'] == null ? undefined : json['merchant_categories'],
        'merchant_prep_time': json['merchant_prep_time'] == null ? undefined : json['merchant_prep_time'],
        'merchant_handoff': json['merchant_handoff'] == null ? undefined : json['merchant_handoff'],
        'merchant_delivery_distance': json['merchant_delivery_distance'] == null ? undefined : json['merchant_delivery_distance'],
        'merchant_brand_size': json['merchant_brand_size'] == null ? undefined : json['merchant_brand_size'],
    };
}

export function ImportBusinessBodyItemToJSON(json: any): ImportBusinessBodyItem {
    return ImportBusinessBodyItemToJSONTyped(json, false);
}

export function ImportBusinessBodyItemToJSONTyped(value?: ImportBusinessBodyItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'devour_merchant_id': value['devour_merchant_id'],
        'olo_vendor_id': value['olo_vendor_id'],
        'chowly_api_key': value['chowly_api_key'],
        'merchant_account_email': value['merchant_account_email'],
        'merchant_parent_id': value['merchant_parent_id'],
        'merchant_name': value['merchant_name'],
        'merchant_internal_name': value['merchant_internal_name'],
        'merchant_description': value['merchant_description'],
        'merchant_email': value['merchant_email'],
        'merchant_phone': value['merchant_phone'],
        'merchant_address_line1': value['merchant_address_line1'],
        'merchant_address_line2': value['merchant_address_line2'],
        'merchant_address_city': value['merchant_address_city'],
        'merchant_address_state': value['merchant_address_state'],
        'merchant_address_zipcode': value['merchant_address_zipcode'],
        'merchant_address_country': value['merchant_address_country'],
        'merchant_address_longitude': value['merchant_address_longitude'],
        'merchant_address_latitude': value['merchant_address_latitude'],
        'merchant_address_place_id': value['merchant_address_place_id'],
        'merchant_timezone': value['merchant_timezone'],
        'merchant_brands': value['merchant_brands'],
        'merchant_categories': value['merchant_categories'],
        'merchant_prep_time': value['merchant_prep_time'],
        'merchant_handoff': value['merchant_handoff'],
        'merchant_delivery_distance': value['merchant_delivery_distance'],
        'merchant_brand_size': value['merchant_brand_size'],
    };
}

